<div class="dialog-header-wrapper">
  <span class="mat-subtitle-1" mat-dialog-title>{{ title }}</span>
  <ds-icon-button (click)="clickButton.emit($event)" color="primary" icon="close" />
</div>
